import { DropDownFilterProps, DropDownFilter } from 'framework/list';
import TechnologyDropdown from '../input/TechnologyDropdown';

const TechnologiesFilter = (props: Omit<DropDownFilterProps, 'children'>) => {
  return (
    <DropDownFilter {...props}>
      <TechnologyDropdown {...props} />
    </DropDownFilter>
  );
};

export default TechnologiesFilter;
